import { useRef } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

const InstructorOne = () => {
  const instructorSliderRef = useRef(null);
  const settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1500,
    dots: false,
    pauseOnHover: true,
    arrows: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 1299,
        settings: {
          slidesToShow: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <section className='instructor py-120 bg-main-25 position-relative z-1'>
      <img
        src='assets/images/shapes/shape2.png'
        alt=''
        className='shape one animation-scalation'
      />
      <img
        src='assets/images/shapes/shape6.png'
        alt=''
        className='shape six animation-scalation'
      />
      <div className='container'>
        <div className='section-heading text-center'>
          <h2 className='mb-24 wow bounceIn'>Bimbel Kusuma</h2>
          <p className=' wow bounceInUp'>
           Bimbel Kusuma merupakan sebuah bimbingan belajar non formal di Jawa Tengah. Kantor pusat Bimbel Kusuma berada di Mlatinorowito Rt.4 Rw.3 Kudus, Jawa Tengah. Bimbel Kusuma juga memiliki cabang lain yaitu Demak, Surakarta, Karanganyar, Sragen, Klaten, Sukoharjo, Pati, Jepara dan Boyolali. Kami menyediakan layanan les privat dengan guru privat terbaik, berpengalaman dan profesional.
          </p>
        </div>
      </div>
    </section>
  );
};

export default InstructorOne;
